import React from "react";
import { XeroClient } from "services";
import { Page, NavItem, TabPane } from "components/common";
import { compose } from "recompose";
import { Nav, TabContent } from "reactstrap";
import Table from "./Table";
import { Trans } from "react-i18next";
import { renderCountSpan } from "services/util";
import { Link, Switch, Redirect } from "react-router-dom";

const getTable = (Status) => (props) =>
(
  <Table
    filters={{
      extra_params: {
        Status,
      },
    }}
    status={Status}
    {...props}
  />
);

const All = getTable();
const Draft = getTable("DRAFT");
const AwaitingApproval = getTable("SUBMITTED");
const Approved = getTable("AUTHORISED");
const Billed = getTable("BILLED");

export const List = ({ match }) => {
  const xero = XeroClient();

  const [pOrders, setPOrders] = React.useState();

  React.useEffect(() => {
    const fetchData = async () => {
      try {

        const response = await xero.get("purchaseorders", {
          params: {
            extra_params: {
              where: 'Type="PURCHASEORDER"',
              //where: 'Type="ACCREC"&&(Status="DRAFT"||Status="AUTHORISED"||Status="SUBMITTED")',
              limit: 100,
            }
          }
        })
        const poData = response.data;
        setPOrders(poData);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  function processAccountData(data) {
    const lengthAll = data ? data.length : 0;
    let lengthDraft = 0;
    let lengthBilled = 0;
    let lengthApproved = 0;
    let lengthSubmitted = 0;

    if (lengthAll > 0) {
      for (let i = 0; i < lengthAll; i++) {
        const status = data[i].Status;

        if (status === "DRAFT") {
          lengthDraft++;
        } else if (status === "BILLED") {
          lengthBilled++;
        } else if (status === "SUBMITTED") {
          lengthSubmitted++;
        } else if (status === "AUTHORISED") {
          lengthApproved++;
        }
      }
    } else {
      console.log("No data available");
    }

    return {
      lengthAll,
      lengthDraft,
      lengthBilled,
      lengthApproved,
      lengthSubmitted,
    };
  }

  const {
    lengthAll,
    lengthDraft,
    lengthBilled,
    lengthApproved,
    lengthSubmitted,
  } = processAccountData(pOrders);


  return (
    <Page className="inv-tabs nw-list" >
      <div>
        <Link to={`${match.url}/edit/new`} className="btn btn-primary ml-0">
          <Trans>New Purchase Order</Trans>
          <span className="mx-1" />
          <span className="fa fa-plus" />
        </Link>

        <Nav tabs className="nw-tabs2 inv-tabs my-3">
          <NavItem to={`${match.url}/all`} translate={false}><Trans>All</Trans> {renderCountSpan(lengthAll)}</NavItem>
          <NavItem to={`${match.url}/draft`} translate={false}><Trans>Draft</Trans> {renderCountSpan(lengthDraft)}</NavItem>
          <NavItem to={`${match.url}/awaiting_approval`} translate={false}>
            <Trans>Awaiting Approval</Trans> {renderCountSpan(lengthSubmitted)}
          </NavItem>
          <NavItem to={`${match.url}/approved`} translate={false}><Trans>Approved</Trans> {renderCountSpan(lengthApproved)}</NavItem>
          <NavItem to={`${match.url}/billed`} translate={false}><Trans>Billed</Trans> {renderCountSpan(lengthBilled)}</NavItem>
        </Nav>
        <TabContent>
          <Switch>
            <TabPane path={`${match.url}/all`} component={All} />
            <TabPane path={`${match.url}/draft`} component={Draft} />
            <TabPane
              path={`${match.url}/awaiting_approval`}
              component={AwaitingApproval}
            />
            <TabPane path={`${match.url}/approved`} component={Approved} />
            <TabPane path={`${match.url}/billed`} component={Billed} />
            <Redirect to={`${match.url}/all`} />
          </Switch>
        </TabContent>
      </div>
    </Page>
  )
};
export const enhance = compose();

export default enhance(List);
